import { RouteObject } from 'react-router/dist/lib/context';
import { MonitoredDevices } from './cpe-statistics/components';
import { SlaStatistics } from './sla-statistics/components/SlaStatistics/SlaStatistics';
import { BitrateStatistics } from "./bitrate-statistics/components/BitrateStatistics/BitrateStatistics";

export enum StatisticsRoutes {
  Sla = 'sla',
  Bitrate = 'bitrate',
  Cpe = 'cpe'
}

export const statisticsRoutes: RouteObject[] = [
  {
    path: StatisticsRoutes.Sla,
    element: <SlaStatistics />,
  },
  {
    path: StatisticsRoutes.Cpe,
    element: <MonitoredDevices />,
  },
  {
    path: StatisticsRoutes.Bitrate,
    element: <BitrateStatistics />,
  },
];